export default "__VITE_ASSET__CbFWguNG__"